import React from 'react'
import { DashPpic } from './DashPpic'

export const DashWip = () => {
  return (
    <DashPpic />
  )
}
